import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { voucherPayment } from 'src/tendering/business-logic/barcode-tender-add';
import { showVoucherBarcodePage } from '../components/voucher-barcode-view';

export const handleVoucherBarcodeCommand = (): void => {
  const onScan = (barcode: string): Promise<void> =>
    voucherPayment(barcode)
      .catch(popupMessage)
      .then(() => restorePage());

  showVoucherBarcodePage({
    onKeypadSubmit: onScan,
    onCancel: () => restorePage(),
    onScan,
  });
};
